import React from 'react';
import { PropTypes } from 'prop-types';
import { BarLoader } from '@unite-us/ui';
import formatSpend from 'common/utils/Money/formatSpend';
import { useFeatureFlag } from 'common/hooks';
import useAuthorizationCapUtilization from '../shared/useAuthorizationCapUtilization';

function AmountAvailableSection({
  feeScheduleProgram,
  person,
  isUnitBased,
  requestedStartsAt,
  requestedEndsAt,
  authorizedAmount,
  setIsAmountExceeded,
  authorization,
}) {
  const isCostBased = !isUnitBased;
  const updateEditAuthorizationsEnabled = useFeatureFlag('pays-5650-update-edit-authorizations');
  const shouldExcludeServiceAuthorizations = updateEditAuthorizationsEnabled && authorization?.state === 'approved';

  const { isFetching, capInfo, availableCap } = useAuthorizationCapUtilization({
    feeScheduleProgram,
    person,
    isUnitBased,
    requestedStartsAt,
    requestedEndsAt,
    authorizedAmount,
    setIsAmountExceeded,
    shouldExcludeServiceAuthorizations,
    authorization,
  });

  if (!capInfo.hasCap) {
    return (
      <p className="mb-4">
        Update authorization details below, then submit request.
      </p>
    );
  }

  const formattedAmountAvailable = formatSpend(availableCap, feeScheduleProgram.unit, isCostBased);

  return (
    <>
      <p className="mb-4">
        Update authorization details below, then submit request.
        {' '}The amount available for authorization is based on the dates requested/cap period.
      </p>
      <div className="mb-4">
        <label className="block mb-2" htmlFor="amount-available-for-authorization">
          Amount Available for Authorization
        </label>
        <p data-test-element="amount-available-for-authorization" id="amount-available-for-authorization">
          {isFetching ? <BarLoader /> : formattedAmountAvailable}
        </p>
      </div>
    </>
  );
}

AmountAvailableSection.propTypes = {
  feeScheduleProgram: PropTypes.object.isRequired,
  person: PropTypes.object.isRequired,
  isUnitBased: PropTypes.bool.isRequired,
  requestedStartsAt: PropTypes.object.isRequired,
  requestedEndsAt: PropTypes.object.isRequired,
  authorizedAmount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  setIsAmountExceeded: PropTypes.func.isRequired,
  authorization: PropTypes.object.isRequired,
};

AmountAvailableSection.defaultProps = {
  authorizedAmount: null,
};

export default AmountAvailableSection;
